import { motion } from "framer-motion";
import { ASSETS } from "./questions";

export const TransitionScreen = ({ onNext }) => (
  <div data-testid="transition-screen" className="flex-1 flex flex-col items-center justify-center px-6 py-10 text-center">
    <motion.img
      src={ASSETS.unpluggedEagle}
      alt="Ashley Falls Eagle mascot enjoying offline fun outdoors"
      className="w-64 sm:w-72 h-auto drop-shadow-[0_12px_24px_rgba(15,23,42,0.15)]"
      initial={{ opacity: 0, scale: 0.85, rotate: -4 }}
      animate={{ opacity: 1, scale: 1, rotate: 0 }}
      transition={{ type: "spring", stiffness: 150, damping: 16 }}
    />
    <motion.h2
      className="font-display mt-6 text-3xl sm:text-4xl font-black uppercase tracking-tight"
      initial={{ opacity: 0, y: 16 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.15 }}
    >
      Awesome!{" "}
      <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 via-pink-500 to-yellow-400">
        Almost there
      </span>
    </motion.h2>
    <motion.div
      className="mt-4 max-w-sm"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ delay: 0.3 }}
    >
      <p className="font-display text-2xl sm:text-3xl font-black uppercase tracking-tight">
        <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 via-pink-500 to-yellow-400">
          Eagles Unplugged
        </span>
      </p>
      <p className="mt-1 font-display text-lg sm:text-xl font-black tracking-tight text-slate-900">
        Wings Out, Screens Off!
      </p>
      <p className="mt-2 font-display text-xs font-extrabold uppercase tracking-[0.15em] text-slate-400">
        (Proudly supported by Kahoots!)
      </p>
      <p className="mt-4 text-base sm:text-lg leading-relaxed text-slate-600">
        "Join our community-wide challenge to help our kids replace 30 minutes of weekly screen time with
        active, offline fun."
      </p>
    </motion.div>
    <motion.button
      data-testid="transition-next-button"
      onClick={onNext}
      className="mt-8 w-full rounded-2xl border-2 border-cyan-400 bg-white px-6 py-5 font-display text-lg font-black uppercase tracking-wide text-slate-900 shadow-[0_0_18px_rgba(6,182,212,0.35)] transition-colors hover:bg-cyan-50 active:scale-[0.97]"
      initial={{ opacity: 0, y: 14 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.45 }}
      whileTap={{ scale: 0.97 }}
    >
      Next
    </motion.button>
  </div>
);
